import axios from "axios";
import { constructProductionUrl, getEnvVariableValue } from "util/CommonUtil";
import HelperService from "./HelperService";
import { ENV_VAR } from "util/Constant";

type HTTP_METHODS = "get" | "post" | "put" | "delete" | "patch";

class BaseApiService {
  private beBaseUrl;
  constructor(props?: any) {
    this.beBaseUrl =
      import.meta.env.MODE === "production" &&
      getEnvVariableValue(ENV_VAR.VITE_ENABLE_CONSTRUCT_URL) === "true"
        ? constructProductionUrl(window.location.origin)
        : getEnvVariableValue(ENV_VAR.BE_BASE_URL) || "";
  }

  getDefaultApiUrl() {
    return this.getBeBaseUrl();
  }

  getAxios() {
    return axios;
  }

  getBeBaseUrl = () => {
    // Refresh from env if not set (for Safari timing issues)

    if (
      import.meta.env.MODE === "production" &&
      getEnvVariableValue(ENV_VAR.VITE_ENABLE_CONSTRUCT_URL) === "true"
    ) {
      this.beBaseUrl = constructProductionUrl(window.location.origin);
    } else {
      this.beBaseUrl = getEnvVariableValue(ENV_VAR.BE_BASE_URL) || "";
    }

    return this.beBaseUrl;

    //return getEnvVariableValue(ENV_VAR.BE_BASE_URL) || "";
  };

  makeGetRequestWithAuth(url: string, config?: any, responseType?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(config?.headers || {}) },
      ...(responseType ? { responseType: responseType } : {}),
      ...(config?.params ? { params: config.params } : {}),
    };
    return this.getAxios().get(url, headersObj);
  }

  makeGetRequest(url: string, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...(headers || {}) },
    };
    return this.getAxios().get(url, headersObj);
  }

  makePostRequestWithAuth(url: string, body?: any, headers?: any, responseType?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
      ...(responseType ? { responseType: responseType } : {}),
    };
    return this.getAxios().post(url, body, headersObj);
  }

  makePostRequestWithAuthForMultiPartFormData(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuthWithMultipartFormData(), ...(headers || {}) },
    };
    return this.getAxios().post(url, body, headersObj);
  }

  makePostRequestWithAuthWithoutObject(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
    };
    return this.getAxios().post(url, body, headersObj);
  }

  makePostRequest(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...(headers || {}) },
    };
    return this.getAxios().post(url, body, headersObj);
  }

  makePutRequestWithAuth(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
    };
    return this.getAxios().put(url, body, headersObj);
  }
  makePatchRequestWithAuth(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
    };
    return this.getAxios().patch(url, body, headersObj);
  }
  makePutRequest(url: string, body?: any, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...(headers || {}) },
    };
    return this.getAxios().put(url, body, headersObj);
  }

  makeDeleteRequestWithAuth(url: string, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
    };
    return this.getAxios().delete(url, headersObj);
  }
  makeDeleteRequest(url: string, headers?: any) {
    url = `${this.getBeBaseUrl()}${url}`;
    const headersObj = {
      headers: { ...(headers || {}) },
    };
    return this.getAxios().delete(url, headersObj);
  }

  axiosConfig(
    url: string,
    method: HTTP_METHODS,
    headers: any = HelperService.getHeaders() ?? undefined,
    data?: any
  ) {
    const config = {
      url: `${this.getBeBaseUrl()}${url}`,
      method,
      headers: {
        ...headers,
      },
      data: data,
    };
    //@ts-ignore :we will fix it later: Need to fix this
    return axios(config);
  }
  axiosConfigWithAuth(url: string, method: HTTP_METHODS, headers?: any, data?: any) {
    let config = {};
    config = {
      url: `${this.getBeBaseUrl()}${url}`,
      method,
      headers: { ...HelperService.getHeadersWithAuth(), ...(headers || {}) },
      data: data,
    };
    //@ts-ignore :we will fix it later: Need to fix this
    return axios(config);
  }
}

export default BaseApiService;
